import { useEffect } from 'react';
import { clampPageNumber } from 'utils/listPagination';

/**
 * Keeps pageNumber within [0, maxPage] after list totals change (filter, delete, refresh).
 * Prevents empty tables and out-of-range API offsets when the user was on a later page.
 */
export const useClampListPagination = ({
  pagination,
  setPagination,
  totalItems,
  isLoading = false,
}) => {
  useEffect(() => {
    if (isLoading || totalItems == null) return;

    const nextPageNumber = clampPageNumber(
      pagination.pageNumber,
      Number(totalItems) || 0,
      pagination.rowsPerPage,
    );

    if (nextPageNumber === pagination.pageNumber) return;

    setPagination((prev) => ({ ...prev, pageNumber: nextPageNumber }));
  }, [isLoading, totalItems, pagination.pageNumber, pagination.rowsPerPage, setPagination]);
};
